<tax-page-header titleText="help.title" id="AnchorTop">
  <div data-qa-block="page-subheader">
    <div *ngIf="adminText" [innerHTML]="adminText" data-qa="subheader-server-text"></div>
    <div class="header__content">
      <div class="header__content_leftblock">
        <div class="tall-text" data-qa="phone">8 800 080 00 51</div>
        <div class="ui-kit-grey-text" translate data-qa="description">
          help.contacts.description
        </div>
      </div>
      <div class="header__content-rightblock tall-text">
        <div translate data-qa="weekday">help.working.time.weekday</div>
        <div translate data-qa="weekend">help.working.time.weekend</div>
      </div>
    </div>
  </div>
</tax-page-header>

<div class="ui-kit-content-container">
  <tax-input
    placeholder="help.searching.placeholder"
    (input)="onInput($event)"
    [(ngModel)]="searchText"
    [autofocus]="true"
    [clearable]="true"
    data-qa="search-input"
  ></tax-input>

  <div class="anchor">
    <a (click)="onClick('AnchorId')" translate data-qa-link="link-to-form">help.form.title</a>
  </div>

  <hr class="greyline" />

  <div data-qa-block="faq-list">
    <div *ngFor="let section of sections" class="text_block" data-qa="faq-item">
      <div class="text_block_title" (click)="section.visible = !section.visible">
        <svg-icon [key]="section.visible ? 'expand-less' : 'expand-more'" class="icon"></svg-icon>
        <span class="ui-kit-block-title" translate data-qa="faq-item-title">{{
          section.question
        }}</span>
      </div>
      <div *ngIf="section.visible" class="text_block_content" translate data-qa="faq-item-text">
        {{ section.answer }}
      </div>
    </div>
  </div>

  <hr class="greyline" />

  <div class="feedback" data-qa-form="feedback">
    <div class="centering-string">
      <svg-icon key="help" class="grey-icon"></svg-icon>
      <span class="ui-kit-block-title" translate data-qa="form-name">help.form.title</span>
    </div>
    <form [formGroup]="feedbackForm" class="feedback_form" (ngSubmit)="sendEmail('AnchorTop')">
      <input
        name="email"
        formControlName="email"
        class="input_field"
        placeholder="{{ 'email.field.name' | translate }}"
        data-qa-input="email"
      />
      <div
        class="form-warning"
        *ngIf="feedbackForm.controls['email'].invalid && feedbackForm.controls['email'].touched"
        translate
      >
        user.form.incorrect.email
      </div>
      <input
        name="subject"
        formControlName="subject"
        class="input_field"
        placeholder="{{ 'help.feedback.subject.placeholder' | translate }}"
        data-qa-input="feedback-subject"
      />
      <div
        class="form-warning"
        *ngIf="feedbackForm.controls['subject'].invalid && feedbackForm.controls['subject'].touched"
        translate
      >
        required.field
      </div>
      <textarea
        name="text"
        formControlName="text"
        class="text_field"
        placeholder="{{ 'help.feedback.body.placeholder' | translate }}"
        rows="3"
        data-qa-input="feedback-text"
      >
      </textarea>
      <div
        class="form-warning"
        *ngIf="feedbackForm.controls['text'].invalid && feedbackForm.controls['text'].touched"
        translate
      >
        required.field
      </div>
      <button
        data-qa-button="send-feedback"
        id="AnchorId"
        class="button_blue"
        [disabled]="feedbackForm.invalid"
        translate
      >
        {{ 'button.send' }}
      </button>
    </form>
  </div>
</div>
